<template>
  <div class="container">
    

      <div class="box p-2 m-t1 border-round">
        <h4>报名学员</h4>
        <div class="m-t2">
          <el-table
            :data="userData"
            size="medium"
          >
            <el-table-column prop="userName" width="100px" label="姓名">
            </el-table-column>
            <el-table-column prop="userGender" width="100px" label="性别">
            </el-table-column>
            <el-table-column prop="userMobile" width="150px" label="手机号">
            </el-table-column>
            <el-table-column
              prop="userEmail"
              width="150px"
              label="电子邮箱"
            >
            </el-table-column>
            <el-table-column prop="userCompany" label="工作单位">
            </el-table-column>
          </el-table>
        </div>
      </div>

  </div>
</template>

<script>
import api from "../../api";
import cookie from "@/api/cookie";
export default {
  data() {
    return {
      id: '',
      userData: []
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.id = this.$route.query.id;
      this.getData()
    },
    getData() {
      console.log(this.id)
      api.userOrderById(this.id).then(res => {
        console.log('userOrderById', res)
        if (res.code === 200 && res.data) {
          res.data.forEach(e => {
            console.log(e.reUserId)
            api.getUserInfo(e.reUserId).then(res1 => {
              // console.log('userProfile', res1.data)
              this.userData.push(res1.data)
              console.log(this.userData)
            })
          });
        }
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  width: 1200px;
  margin: 20px auto;
  padding: 20px;
  background: #ffffff;
  min-height: 700px;
}

</style>